/**
 * Named visibility tags for @colyseus/schema's @view() decorator.
 *
 * Every tag MUST be a positive integer. The library reserves -1 for
 * DEFAULT_VIEW_TAG (used by bare @view()); use of named tags keeps the
 * project's visibility taxonomy declarative and iterable.
 *
 * Adding a new tag is additive — declare it here, document its meaning,
 * and update any room that should grant that visibility.
 *
 * Removing or renumbering a tag breaks every server room that calls
 * view.add(entity, VIEW_TAGS.<NAME>): the numeric value is baked into
 * compiled room code. If you must renumber, treat it as a deployment
 * breaking change and bump SCHEMA_VERSION to force a coordinated rollout.
 */
export const VIEW_TAGS = {
    /** Visible only to the owning client (sessionId-matched). */
    SELF: 1,
    /** Visible to all clients whose role is Ghost. */
    GHOSTS: 2,
    /** Visible to all clients once a player has been role-revealed. */
    REVEALED: 3,
};
//# sourceMappingURL=view-tags.js.map